import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=332b6ec7&"
import script from "./LoadData.vue?vue&type=script&lang=js&"
export * from "./LoadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports